// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8c3d1db2","93":"8837d76e","138":"e2e89617","270":"dd666a81","404":"7dae82bf","488":"b2a64b34","545":"daff19af","580":"abc3a393","686":"2b9e34ec","706":"44ba4c26","801":"2d3f0f31","888":"2902bd3c"}[chunkId] + ".chunk.js";
};